import React, { Component } from 'react';
import { connect } from 'react-redux';
import RemoteImageReferralListWrap from '../../../views/remoteImage/referral/list/RemoteImageReferralListWrap';
import { remoteImageActions } from '../../../store/modules/remoteImage';

class RemoteImageReferralListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    this.getList();
  };

  /**
   *  리스트 가져오기
   */
  getList = (data) => {
    const { pageType, getRemoteImageReferralList, remoteImageReferralList } = this.props;
    const { searchOption, pagination } = remoteImageReferralList;

    getRemoteImageReferralList({
      pageType,
      searchOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { remoteImageReferralList, setData } = this.props;

    return (
      <RemoteImageReferralListWrap
        remoteImageReferralList={remoteImageReferralList}
        setData={setData}
        getList={this.getList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    remoteImageReferralList: state.remoteImage.remoteImageReferralList,
  };
};

const mapDispatchToProps = {
  setData: remoteImageActions.setData,
  getRemoteImageReferralList: remoteImageActions.getRemoteImageReferralList,
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoteImageReferralListContainer);
